// ----------------------------------------------------- GLOBAL VARS //
let google;
  let id;
  let viewportWidth;
  let mobileDevice;
  let mobileSmall;
  let mobile;
  let tabletSmall;
  let tablet;
  let desktop;

// ----------------------------------------------------- GLOBAL //
const GlobalInit = {
  init() {
    this.setDeviceClass();
    this.orientationChange.setHeights();
  },
  setDeviceClass() {
    // Mobile Small //
    if (window.innerWidth <= 480) {
      viewportWidth = 480;
      mobileSmall = mobileDevice = true;
      mobile = tabletSmall = tablet = desktop = false;

      $('body').addClass('mobile');
    }
    // Mobile //
    else if (window.innerWidth <= 767) {
      viewportWidth = 767;
      mobile = mobileDevice = true;
      mobileSmall = tabletSmall = tablet = desktop = false;

      $('body').addClass('mobile');
    }
    // Tablet Portrait //
    else if (window.innerWidth <= 992) {
      viewportWidth = 992;
      tabletSmall = true;
      mobileDevice = mobileSmall = mobile = tablet = desktop = false;

      $('body').removeClass('mobile');
      $('body').addClass('tablet-sm');
    }
    // Tablet Landscape //
    else if (window.innerWidth <= 1200) {
      viewportWidth = 1200;
      tablet = true;
      mobileDevice = mobileSmall = mobile = tabletSmall = desktop = false;

      $('body').removeClass('mobile tablet-sm');
      $('body').addClass('tablet');
    }
    // Desktop //
    else {
      desktop = true;
      mobileDevice = mobileSmall = mobile = tabletSmall = tablet = false;

      $('body').removeClass('mobile tablet-sm tablet');
    }

    if (!mobileDevice) {
      $('.content-top').css({
        height: '',
        'max-height': '',
      });
      this.orientationChange.setHeights();
    }
  },
  scrollToContentMain() {
    // SCROLL TO CONTENT MAIN //
    if (desktop) {
      $('html, body').animate({
        scrollTop: $('.content-main').offset().top - $('header').height(),
      }, 1000);
    }
    else {
      $('html, body').animate({
        scrollTop: $('.content-main').offset().top,
      }, 1000);
    }
  },
  orientationChange: {
    setContentTop() {
      $('.content-top').css({
        height: document.documentElement.clientHeight,
        'max-height': document.documentElement.clientHeight,
      });
    },
    setHeights() {
      if (mobile && !mobileSmall) {
        this.setContentTop();
        $('.hero').css('background-size', 'cover');
      }
      else if (!mobileDevice) {
        $('.hero').css('background-size', 'cover');
        $('.hero, .screen').css({
          height: '',
          'max-height': '',
        });
      }

      if (mobileSmall && document.body.id !== 'home') {
        this.setContentTop();
        $('.hero').css({
          'background-size': `auto ${document.documentElement.clientHeight + 20}px`,
        });
        $('.hero, .screen').css({
          height: document.documentElement.clientHeight + 20,
          'max-height': document.documentElement.clientHeight + 20,
        });
      }
    },
  },
};

GlobalInit.init();
$(window).on('resize', () => {
  GlobalInit.setDeviceClass();
});

// ------------------------------------------------------ Page Animations //
const topScene = {
  elms: [
  '.top-container',
  '.testimonial-section',
  '.leadership-container',
  ],
};

const testimonialScene = {
  elms: [
  '.testimonial-container',
  ],
  offset: viewportHeight / 1.90,
};

buildScenes(topScene);
buildScenes(testimonialScene);

// ------------------------------------------------------ Testimonials //
let testimonial = setInterval(testimonialsTimer, 10000);
const quote = document.getElementsByClassName('quote');
let quoteCount = 1;
const quoteCountMax = quote.length;

function testimonialsTimer() {
  $(`.quote-${quoteCount}`).removeClass('vis');
  $(`.dot-${quoteCount}`).removeClass('active');

  if (quoteCount !== quoteCountMax) {
    quoteCount += 1;
  }
  else {
    quoteCount = 1;
  }

  $(`.quote-${quoteCount}`).addClass('vis');
  $(`.dot-${quoteCount}`).addClass('active');
}

// Hacky stuff to get nav working //
$('body').on('click', '.dot-nav li', function() {
  const slideNumber = $(this).data('slide');
  quoteCount = slideNumber - 1;

  $('.quote, .quote-img').removeClass('vis');
  $('.dot').removeClass('active');

  if (quoteCount !== quoteCountMax) {
    quoteCount += 1;
  }
  else {
    quoteCount = 1;
  }

  $(`.quote-${quoteCount}`).addClass('vis');
  $(`.dot-${quoteCount}`).addClass('active');

  // reset setInterval
  clearInterval(testimonial);
  testimonial = setInterval(testimonialsTimer, 10000);
});

// ----------------------------------------------------- Leadership //
const leadership = function() {
  let cardID;
  let dataSet;
  let thisDataSetInfo;
  let cardHeight = 0;
  const card = $(document.getElementsByClassName('card')[0]).clone().addClass('temp');

  // Set .data-set-info css //
  $('.data-set-info').css('height', 'auto').not('.active').css('display', 'none');
  $('.data-set-info.active').css('height', cardHeight + 100);

  // .leaders client event //
  $('.leaders li').on('click', function() {
    cardID = $(this).data('card');
    dataSet = $(this).parents('.data-set').data('set');
    thisDataSetInfo = $(this).parents('.row').children('.data-set-info');

    if ($(':animated').length) {
      return false;
    }

    if (mobileDevice) {
      window.location = `/about/leadership-profile/${$(this).attr('data-slug')}`;
      return false;
    }

    if (tabletSmall) {
      window.location = `/about/leadership-profile/${$(this).attr('data-slug')}`;
      return false;
    }

    // Add CSS transition to parent .data-set-info if child .card.active //
    $('.card.active').parents('.data-set-info').css('transition', 'height .25s ease');

    // Remove and add .active class to elements //
    $('.data-set, .leaders li, .leaders img, .card').removeClass('active');
    $(this).parent('li').addClass('active');
    $(this).add(`.data-set[data-set=${dataSet}], .card[data-card=${cardID}]`).addClass('active');

    $('body').append(card);
    cardHeight = $(card).height();
    $('.card.temp').remove();

    $(thisDataSetInfo).css('height', cardHeight + 100);

    // Open .data-set-info.active //
    if (!$(thisDataSetInfo).hasClass('active')) {
      $('.data-set-info').css('transition', '').slideUp().removeClass('active');
      $(thisDataSetInfo).slideDown().addClass('active');
    }

    return false;
  });

  // Adjust cards on windows resize //
  $(window).on('resize', () => {
    cardHeight = $('.card.active').height();
    $('.leaders img.active').parents('.row').children('.data-set-info').css('height', cardHeight + 100);
  });
};

leadership();

// ----------------------------------------------------- Sub Page Go To Position //
if (subSubPage && subPid !== '0' && subPid !== '') {
  const leadershipContainer = document.getElementById(subPid);
  const elmPosition = getPosition(leadershipContainer);

  if (subPid === 'leadership') {
    elmPosition.y += 70;
  }

  pageDownScroll('auto', elmPosition.y);
}
